export default __webpack_public_path__ + "static/media/pragna_college.e9aab90a.png";